export default __webpack_public_path__ + "d095db2a74c6b9363e08d9951826b57321b59941/161a231856ba99f96b16b1f91115e718.png";